import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    defaultMessage: 'Activate Your Carriers',
    description:
      'Title for the modal that appears when a user without plan that includes access to non wallet carriers clicks the "Add Carrier" button',
    id: 'kpZ0/N',
  },
  modalBody: {
    defaultMessage: 'Using your own carrier accounts adds a {addOnPrice}/mo fee to the {planName} Plan.',
    description:
      'Body for the modal that appears when a user without a plan that includes access to non wallet carriers clicks the "Add Carrier" button',
    id: 'ANj3/5',
  },
  modalBodyTrial: {
    defaultMessage:
      'Connecting your own carrier accounts is free during your trial period. Once you subscribe to a ShipStation plan, this feature will incur a monthly fee in addition to your subscription cost.',
    description:
      'Body for the modal that appears when a user in trial without a plan that includes access to non wallet carriers clicks the "Add Carrier" button',
    id: '0Z81+Z',
  },
  modalBodyTrial2: {
    defaultMessage:
      "When you are ready to select a plan, you can keep the Your Carriers feature active or you can deactivate it. Whichever you choose, you'll always have access to the great rates and services provided with ShipStation Carriers.",
    description:
      'Additional message for the modal that appears when a user in trial without a plan that includes access to non wallet carriers',
    id: 'LZ9/ZU',
  },
  newMonthlySubscriptionText: {
    defaultMessage: 'New monthly cost',
    description: 'Text denoting the new monthly subscription fee that will be charged to the user',
    id: 'cS9llV',
  },
  billingMessage: {
    defaultMessage:
      "Once confirmed, you'll be charged a prorated fee for the remaining days in your billing cycle. View and manage the Your Carriers add on in the Payment & Subscription Settings.",
    description:
      'Message to inform the user that the new monthly subscription fee will be reflected immediately in their subscription statement',
    id: 'DmIXrs',
  },
  billingMessageButHasRemainingTrial: {
    defaultMessage:
      "Once confirmed, you'll be charged your subscription plan fee and Your Carriers add on fee on the first day of your billing cycle. View and manage the Your Carriers add on in the Payment & Subscription Settings.",
    id: 'j5z6Hs',
    description: 'Message to inform the user that the new monthly subscription fee will be reflected in their next subscription statement',
  },
  confirmButton: {
    defaultMessage: 'Confirm',
    description: "Modal button to confirm the user's decision to unlock access to non wallet carriers feature",
    id: 'vNsWqW',
  },
  connectCarrierButton: {
    defaultMessage: 'Connect Carrier',
    description: "Modal button to confirm the user's decision to add a non wallet carrier while in a trial",
    id: '3bFqya',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: "Modal button to cancel the user's decision to unlock access to non wallet carriers feature",
    id: 'rHTbf9',
  },
  errorNotificationTitle: {
    defaultMessage: 'Unable to add Your Carriers feature',
    description: 'The title in the toast notification denoting there was an error adding the non wallet access plan',
    id: 'p+7EyO',
  },
  errorNotificationMessage: {
    defaultMessage: 'Please update your billing details then try to activate the Your Carriers feature again.',
    description:
      'The message in the toast notification telling the user to check their billing information on the payment and subscription page',
    id: 'gNJIal',
  },
  updateBilling: {
    defaultMessage: 'Update Billing',
    description: 'The button title to link the users to payments and subscription page',
    id: 'lWStlM',
  },
  dismissButton: {
    defaultMessage: 'Dismiss',
    description: 'The button that dismisses the error notification',
    id: '4jLQDh',
  },
  noPermission: {
    defaultMessage:
      'You do not have permissions to make changes to the subscription plan. Contact your account administrator to make these changes.',
    description: 'Error banner telling acting user they do not have permission to update plan',
    id: 'b9jNHT',
  },
});
